import i18n from "i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import translationEN from "../src/locales/en/translation.json";
import translationSP from "../src/locales/sp/translation.json";
import translationCH from "../src/locales/ch/translation.json";
import translationGE from "../src/locales/ge/translation.json";
import translationFR from "../src/locales/fr/translation.json";
import translationJA from "../src/locales/ja/translation.json";
import translationRU from "../src/locales/ru/translation.json";
import translationPO from "../src/locales/po/translation.json";

const resources = {
  en: {
    translation: translationEN
  },
  sp: {
    translation: translationSP
  },
  ch: {
    translation: translationCH
  },
  ge: {
    translation: translationGE
  },
  fr: {
    translation: translationFR
  },
  ja: {
    translation: translationJA
  },
  ru: {
    translation: translationRU
  },
  po: {
    translation: translationPO
  }
};

i18n
  .use(Backend)

  .use(LanguageDetector)

  .use(initReactI18next)

  .init({
    resources,
    fallbackLng: "en",
    debug: true,
    lng: "en",
    interpolation: {
      escapeValue: false // not needed for react as it escapes by default
    },
    react: { 
      useSuspense: false //   <---- this will do the magic
    }
  });

export default i18n;
